import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp() {
  const [num, setNum] = useState("919353480980");

  useEffect(() => {
    api.get("/config/public").then((r) => r.data?.whatsapp_number && setNum(r.data.whatsapp_number)).catch(() => {});
  }, []);

  const text = encodeURIComponent("Hi Aroha Homes! I'd like to enquire about a stay.");

  return (
    <a
      href={`https://wa.me/${num}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <span className="relative flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3.5 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300">
        <MessageCircle size={20} strokeWidth={2} />
        <span className="font-sans text-sm font-semibold hidden sm:inline">Chat with us</span>
      </span>
    </a>
  );
}
